import React, { Component } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import Home from "./Home";
import { SnackbarProvider } from "notistack";
import firebase from "firebase/app";

// import Login from './Login';
import Auth from "./Auth";

// Add in styles
import "../styles/App.css";

// Google Analytics
import ReactGA from "react-ga";
// Initialize google Analytics
ReactGA.initialize("UA-137946702-1");

class HomeRouter extends Component {
  constructor() {
    super();
    this.state = {
      isUserLogged: false
    };
  }
  componentWillMount() {
    // DEPRECATED CODE
    //Everytime a path changes the listener will update the google analytics data
    //this.props.history.listen(location => ReactGA.pageview(location.pathname));
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.props.history.listen(location => ReactGA.pageview(user.displayName + location.pathname));
        this.setState({ isUserLogged: true });
        this.props.history.push(`/dashboard`);
      } else {
        this.setState({ isUserLogged: false });
        this.props.history.push(`/`);
      }
    });
  }

  render() {
    if (this.state.isUserLogged) {
      return (
        <Switch>
          <Route exact path="/" render={() => <Auth />} />
          <Route
            path="/:clientId/"
            history
            render={props => (
              <SnackbarProvider
                maxSnack={2}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right"
                }}
                autoHideDuration={2500}
                preventDuplicate={true}
              >
                <Home clientId={props.match} />
              </SnackbarProvider>
            )}
          />
        </Switch>
      );
    } else {
      return (
        <Switch>
          <Route exact path="/" render={() => <Auth />} />
        </Switch>
      );
    }
  }
}

export default withRouter(HomeRouter);
